export enum Paths {
  Dashboard = "/",

  // Students path
  StudentList = "/student-list",
  StudentDetails = `/student`,
  StudentAdmission = "/student-admission",
  // -----------

  // Parents path
  RegisterParent = "/register-parent",
  ParentsList = "/parents-list",
  ParentsDetail = "/parent",
  // --------

  // Teacher path
  RegisterTeachers = "/register-teacher",
  TeachersList = "/teachers-list",
  TeacherDetail = "/teacher/:teacherId",
  // --------

  // Auth path
  Login = "/login",
  Signup = "/signup",
  ForgotPassword = "/forgot-password",
  ResetPassword = "/reset-password",
  // --------

  // Subject path
  Subject = "/subject",

  // Branches path
  Branch = "/branch",

  // Blocks path
  Block = "/blocks",

  // Class path
  Class = "/class",

  // Transport
  Transport = "/transport",

  // Notification
  Notification = "/notification",

  // Result
  AddResult = "/add-result",
  ResultDetails = "/result",

  // Prices
  SchoolPrices = "/school-prices",
}
